import { useQuery } from '@apollo/client';

import { GET_CONTRIBUTOR, GetContributorQuery, GetContributorQueryVariables } from '@neo.tax/shared';

import { useAscContext } from '../context';

export type Contributor = GetContributorQuery['getContributor'];
export type AscProjectPerContributor = Contributor['ascProjectsPerContributor'][number];
export type AscProjectMonthPerContributor = AscProjectPerContributor['ascProjectMonthsPerContributor'][number];

// Using two difference function signatures to allow for optional options and to return null as an
// option for a contributor when skipping
export function useContributor(
  contributorId: string,
  options?: undefined,
):
  | {
      contributor: null;
      loading: true;
    }
  | {
      contributor: Contributor;
      loading: false;
    };
export function useContributor(
  contributorId: string,
  options: { skip: boolean },
):
  | {
      contributor: null;
      loading: true;
    }
  | {
      contributor: Contributor | null;
      loading: false;
    };

export function useContributor(
  contributorId: string,
  options?: { skip: boolean },
):
  | {
      contributor: null;
      loading: true;
    }
  | {
      contributor: Contributor | null;
      loading: false;
    } {
  const { skip } = {
    skip: false,
    ...options,
  };
  const { fiscalYearId, periodName } = useAscContext();

  const { data, error, loading } = useQuery<GetContributorQuery, GetContributorQueryVariables>(GET_CONTRIBUTOR, {
    variables: { contributorId, fiscalYearId, periodName },
    skip,
  });

  if (loading) {
    return { contributor: null, loading: true };
  }
  if (error) {
    throw error;
  }

  return {
    contributor: data?.getContributor ?? null,
    loading,
  };
}
